/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Document_Supplier_InvoiceInputs */

const en_inbound_document_supplier_invoice = /** @type {(inputs: Inbound_Document_Supplier_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Inbound_Document_Supplier_InvoiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_document_supplier_invoice = /** @type {((inputs?: Inbound_Document_Supplier_InvoiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Document_Supplier_InvoiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_document_supplier_invoice(inputs)
});